import React from 'react';
import { useTranslation } from 'react-i18next';

const BusinessSpeedInfoCard = ({ speed }) => {
  const {t} = useTranslation();
  const getSpeedDetails = (speedValue) => {
    if (speedValue <= 300) {
      return { label: t('common.smallBusiness') };
    } else if (speedValue <= 1000) {
      return { label: t('common.mediumBusiness') };
    } else {
      return { label: t('common.largeBusiness') };
    }
  };

  const { label } = getSpeedDetails(speed ?? 0);

  return (
    <h4 className={'plans-header__title'}>{label}</h4>
  )
}

export default BusinessSpeedInfoCard
